import React from 'react';
import { Home, List, Handshake, Wallet, Receipt, User } from 'lucide-react';
import { motion } from 'framer-motion';
type View = 'home' | 'transactions' | 'debts' | 'savings' | 'bills' | 'account';
interface BottomNavProps {
  currentView: View;
  onChange: (view: View) => void;
  pendingRequestsCount?: number;
}
export function BottomNav({
  currentView,
  onChange,
  pendingRequestsCount = 0
}: BottomNavProps) {
  const navItems = [{
    id: 'home',
    icon: Home,
    label: 'Home'
  }, {
    id: 'transactions',
    icon: List,
    label: 'Activity'
  }, {
    id: 'debts',
    icon: Handshake,
    label: 'Debts'
  }, {
    id: 'savings',
    icon: Wallet,
    label: 'Savings'
  }, {
    id: 'bills',
    icon: Receipt,
    label: 'Bills'
  }, {
    id: 'account',
    icon: User,
    label: 'Account'
  }] as const;
  return <nav className="fixed bottom-0 left-0 right-0 bg-stone-900/90 backdrop-blur-lg border-t border-stone-800 pb-safe pt-2 px-2 z-40" data-id="element-31">
      <div className="flex justify-around items-center max-w-md mx-auto h-16" data-id="element-32">
        {navItems.map(item => {
        const isActive = currentView === item.id;
        const showBadge = item.id === 'account' && pendingRequestsCount > 0;
        return <button key={item.id} onClick={() => onChange(item.id)} className="relative flex flex-col items-center justify-center w-14 h-full" data-id="element-33">
              {isActive && <motion.div layoutId="nav-pill" className="absolute -top-1 w-10 h-1 bg-amber-500 rounded-full" transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} data-id="element-34" />}
              <div className="relative" data-id="element-35">
                <item.icon size={20} className={`transition-colors duration-200 ${isActive ? 'text-amber-500' : 'text-stone-500'}`} data-id="element-36" />
                {showBadge && <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center" data-id="element-37">
                    <span className="text-white text-[9px] font-bold" data-id="element-38">
                      {pendingRequestsCount > 9 ? '9+' : pendingRequestsCount}
                    </span>
                  </motion.div>}
              </div>
              <span className={`text-[9px] mt-1 font-medium transition-colors duration-200 ${isActive ? 'text-amber-500' : 'text-stone-500'}`} data-id="element-39">
                {item.label}
              </span>
            </button>;
      })}
      </div>
    </nav>;
}